import React from "react";
//#region types
//#endregion
//#region components
import { Divider, Grid, Toolbar, AppBar } from "@mui/material";
import { NotificationsContainer, CompanyListContainer, SearchBar, LanguageToggle } from "components/layout/header";
import { Link } from "react-router-dom";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import Logo from "images/logo-small.png";
import { UrlHelper, EnvHelper } from "utils/helpers";

const Header: React.FC = () => {
  return (
    <Grid item className={cssExports.headerContainer}>
      <AppBar position="static" className={cssExports.appBar}>
        <Toolbar className={cssExports.toolBar}>
          <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={1}>
            <Grid item>
              <Link to={UrlHelper.formatPath("/")}>
                <img src={Logo} className={cssExports.headerLogoImg} />
              </Link>
            </Grid>
            <Grid item>
              <Divider className={cssExports.verticalLine} orientation={"vertical"}></Divider>
            </Grid>
            <Grid item xs>
              <SearchBar />
            </Grid>
            <Grid item>
              <CompanyListContainer />
            </Grid>
            <Grid item>
              <NotificationsContainer />
            </Grid>
            {/* Warn: Only for non-production environments */}
            {!EnvHelper.getIsProductionEnvironment() && (
              <Grid item>
                <LanguageToggle />
              </Grid>
            )}
          </Grid>
        </Toolbar>
      </AppBar>
    </Grid>
  );
};

export default Header;
